import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import AppBar from "@mui/material/AppBar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field, FieldArray } from "formik";
import {
  Divider,
  Paper,
  MenuItem,
  Menu,
  IconButton,
  Stack,
  Tabs,
  Tab,
  Chip,
} from "@mui/material";
import {
  GetBranch,
  PostUser,
  UpdateUser,
  GetUser,
  GetPayout,
  GetFileFromAWSS3BucketByKey,
  verifyMobileNumber,
  verifyEmailAddress,
} from "../../Service/_index";
import { FileUploader } from "react-drag-drop-files";
import { ChangeCredentials, GetProviderCredentials } from "../../Service/UserService";
import { ToastError, ToastSuccess } from "../../UiComponents/Toaster/Toast";
import {
  AddIcon,
  CloseIcon,
  DeleteIcon,
  RemoveRedEyeIcon,
  CloudOffIcon,
  EditIcon,
  VisibilityOffIcon,
  VisibilityIcon
} from "../../Resources/Icons/icons";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import * as Yup from "yup";
import {
  FilterOption,
  checkUserType,
  AWS_DIRECTORY_NAME,
  PolicyFilterTypes,
  filterOption,
  filterSort,
  PROVIDER_COMPANIES,
} from "../../Shared/CommonConstant";
import AddBranch from "../Master/Branch/AddBranch";
import Drawer from "@mui/material/Drawer";
import Tooltip from "@mui/material/Tooltip";
import DownloadIcon from "@mui/icons-material/Download";
import ReactDOMServer from "react-dom/server";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../UiComponents/Loader/Loader";
import ViewPdfFiles from "../ViewPdfFiles/ViewPfdFiles";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import AddBankDrawer from "./AddBankDrawer";
import { Select, Space } from "antd";
import Dialog from "@mui/material/Dialog";
import { Transition } from "../../UiComponents/Transition/Transition";

import { GetMakeModel, GetRtoCityLocation, GetClient, GetMakeModelCombo } from "../../Service/_index";
import AddMakeModelDrawer from "./AddMakeModelDrawer";
import AddRtoCityDrawer from "./AddRtoCityDrawer";
import AddMakeModelComboDrawer from "./AddMakeModelComboDrawer";
import Styles from "./User.module.scss";
// the Edit dialogs' look for this page only (scoped by .op-form / .user-form on the root)
import "../Policy/OnlinePolicy/components/onlinePolicyForm.scss";
import { useOnlinePolicyConfig } from "../Policy/OnlinePolicy/hooks/useOnlinePolicyConfig";
import { credentialSettingsShown } from "../Policy/OnlinePolicy/utils/credentialVisibility";
import "./userForm.scss";
// import { FaUpload } from "react-icons/fa";
import MoreVertIcon from "@mui/icons-material/MoreVert";

//New

import TableSortLabel from "@mui/material/TableSortLabel";
import PropTypes from "prop-types";
import { visuallyHidden } from "@mui/utils";
import MasterCommonTable from "../../UiComponents/CommonTable/MasterCommonTable";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
const { Option } = Select;

const AddUser = (props) => {
  // The portal login settings: a `user` login sees them only while SHOW_USER_CRETENTIAL_UBDATE is on; every other login
  // (an admin viewing or editing a user included) always does.
  const showUserCredentialUpdate = credentialSettingsShown(useOnlinePolicyConfig().showUserCredentialUpdate);
  const { selectedData, formType, setOpenDrawer, title, GetData, source } =
    props;
  const [branchData, setBranchData] = useState({});
  const [user, setUser] = useState([]);
  const [userEmail, setUserEmail] = useState([]);
  const [showOPPassword, setShowOPPassword] = useState(false);
  // The logins as they were loaded from the server, kept so onSubmit can tell
  // whether the operator actually changed anything. `selectedData` no longer
  // carries them — they come from the ProviderCredential collection.
  const [loadedCredentials, setLoadedCredentials] = useState([]);
  const [roleFilter, setRoleFilter] = useState(
    formType === "edit" ? selectedData?.userType || [] : []
  );
  // Only these two roles can be given to a user from this form. A user who
  // ALREADY has another role (Branch Manager, Accountant, ...) still shows and
  // keeps it on edit — it is just no longer offered to anyone else.
  // A SUPER_ADMIN picks which client (admin) the new user belongs to; it
  // defaults to his own. Everyone else is always creating under their own client.
  const isSuperAdmin = sessionStorage.getItem("roleId") === "SUPER_ADMIN";
  const ownClientId = sessionStorage.getItem("clientID") || "";
  const [adminOptions, setAdminOptions] = useState([]);
  useEffect(() => {
    if (!isSuperAdmin || formType === "edit") return;
    GetClient().then((res) => {
      setAdminOptions(
        (res?.data || [])
          // The super admin is the operator, not an admin with users of his own: he is not offered here (the server
          // refuses it as well — shared/superAdmin.js).
          .filter((c) => String(c.roleId || "").trim().toUpperCase() !== "SUPER_ADMIN")
          .map((c) => ({
            value: c._id,
            label: c.name || c.client || c.email || c._id,
          }))
      );
    });
  }, []);
  const userTypeOptions = FilterOption.filter(
    (el) =>
      ["operator", "user"].includes(el.value) ||
      (formType === "edit" ? [].concat(selectedData?.userType || []) : []).includes(el.value)
  );
  const [branchValue, setBranchValue] = useState(
    formType === "edit" ? selectedData?.branchId?.branchName : null
  );
  const [branchManagerValue, setBranchManagerValue] = useState(
    formType === "edit" ? selectedData?.branchManager?.name : null
  );
  const [openBranchDrawer, setOpenBranchDrawer] = React.useState(false);
  const [openAddBankDrawer, setOpenAddBankDrawer] = React.useState(false);
  const [openLoader, setOpenLoader] = useState(false);
  const [editBankDrawerFormType, setEditBankDrawerFormType] = useState(null);
  const [defaultLocationDetails, setDefaultLocationDetails] = useState(
    formType === "edit" ? selectedData?.userType || [] : []
  );
  const [fileTitle, setFileTitle] = useState({});
  const availableCompanies = PROVIDER_COMPANIES;

  // defined by gokul...
  const [showMobileErrMsg, setShowMobileErrMsg] = useState("");
  const [showEmailErrMsg, setShowEmailErrMsg] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget); // Show the menu when MoreVertIcon is clicked
  };

  const handleClose = () => {
    setAnchorEl(null); // Close the menu when an option is selected or clicked outside
  };

  const [tableConfig, setTableConfig] = useState({
    isAction: true,
    // isView: true,
    isEdit: true,
    isDelete: true,
    // isSearch: true,
    // isApprove: true,
  });
  const navigate = useNavigate();
  function stableSort(array, comparator) {
    const stabilizedThis = array?.map((el, index) => [el, index]);
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis?.map((el) => el[0]);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  const getClassName = (data) => {
    return data.status == "Active"
      ? "Active-chip"
      : data.status == "Inactive"
        ? " inActive-chip"
        : "";
  };

  const headCells = [
    {
      id: "bankAccountHolderName",
      placeMent: true,
      disablePadding: false,
      label: "Account Holder Name",
    },
    {
      id: "accountNumber",
      placeMent: true,
      disablePadding: false,
      label: "Account Number",
    },
    {
      id: "bankName",
      placeMent: true,
      disablePadding: false,
      label: "Bank Name",
      // class: getClassName,
    },
    {
      id: "bankBranch",
      placeMent: true,
      disablePadding: false,
      label: "Bank Branch",
    },
    {
      id: "ifscCode",
      placeMent: true,
      disablePadding: false,
      label: "IFSC Code",
    },
    {
      id: "micrNumber",
      placeMent: true,
      disablePadding: false,
      label: "MICR Number",
    },
    {
      id: "panNumber",
      placeMent: true,
      disablePadding: false,
      label: "Pan Number",
    },
    {
      id: "aadharNumber",
      placeMent: true,
      disablePadding: false,
      label: "Aadhar Number",
    },
    {
      id: "gstNumber",
      placeMent: true,
      disablePadding: false,
      label: "GST Number",
    },
    {
      id: "tds",
      placeMent: true,
      disablePadding: false,
      label: "TDS Percentage",
    },
    // {
    //   id: "action",
    //   placeMent: false,
    //   disablePadding: false,
    //   label: "Action",
    // },
  ];

  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {headCells?.map((headCell) => (
            <TableCell
              className="TableHeader"
              key={headCell.id}
              align={headCell.placeMent ? "left" : "center"}
              padding={headCell.disablePadding ? "none" : "normal"}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{ fontSize: "16px", fontWeight: 600 }}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box sx={visuallyHidden}>
                    {order === "desc"
                      ? "sorted descending"
                      : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
  };

  //   const [anchorEl, setAnchorEl] = useState(null);
  //   // Function to handle Popper open/close
  //   const handleClick = (event) => {
  //     if (anchorEl) {
  //       setAnchorEl(null); // Close Popper if it's already open
  //     } else {
  //       setAnchorEl(event.currentTarget); // Open Popper when icon is clicked
  //     }
  //   };

  //   // Function to handle close when clicking away
  //   const handleClose = () => {
  //     setAnchorEl(null);
  //   };

  let formRef = useRef();
  const initialValues = {
    userType: "",
    branchId: null,
    branchManager: null,
    name: "",
    mobileNumber: "",
    email: "",
    address: "",
    clientId: "",
    // Which client (admin) the new user is created under — SUPER_ADMIN only. Empty for him: he is never the owner
    // (users are not created under the super admin), so an admin has to be chosen. Everyone else creates under their own.
    adminClientId: isSuperAdmin ? "" : ownClientId,
    password: "",
    aadharNumber: "",
    tds: "",
    panNumber: "",
    gstNumber: "",
    bankAccountHolderName: "",
    accountNumber: "",
    bankName: "",
    bankBranch: "",
    ifscCode: "",
    micrNumber: "",
    payoutCycle: "",
    idProof: "",
    walletPassword: "", //Changes by Arun
    // One row per insurer, filled in from the server on edit.
    providerCredentials: PROVIDER_COMPANIES.map((companyName) => ({
      companyName,
      onlinePolicyUserName: "",
      onlinePolicyPassword: "",
      onlinePolicyLoginUrl: "",
    })),
  };

  const PayoutOption = [
    {
      label: "DAILY PAYOUT",
      value: "Daily",
    },
    {
      label: "WEEKLY PAYOUT",
      value: "Weekly",
    },
    {
      label: "MONTHLY PAYOUT",
      value: "Monthly",
    },
  ];

  const GetUserDetails = () => {
    GetUser({ isAscending: true }).then((res) => {
      const modifiedUser = res?.data?.map((e) => {
        return {
          ...e,
          label: e.name,
          value: e._id,
        };
      });
      setUserEmail(modifiedUser.map((res) => res.email));
      const FilterUserType = modifiedUser?.filter(
        (item) => item.userType?.includes("branchManager") && item.isEnabled
      );
      setUser(FilterUserType);
    });
  };

  const [emailErrMsg, setEmailErrMsg] = useState("");
  const EmailValitaionFunction = (e) => {
    if (userEmail.includes(e.target.value)) {
      setEmailErrMsg("Email Already Exsists");
    } else {
      setEmailErrMsg("");
    }
  };
  // Exactly one row per insurer, always in the same order — the credential
  // section is a TAB STRIP, and each tab owns one row.
  //
  // This is what makes a duplicate impossible: the company is a property of the
  // tab, not something the operator picks, so there is no way to name the same
  // insurer twice. (The server still checks — see dao/userDao.js — because the
  // API is reachable without this form.)
  const buildCredentialRows = (loaded) =>
    availableCompanies.map((company) => {
      const existing = (loaded || []).find(
        (row) =>
          (row?.companyName || "").trim().toLowerCase() === company.toLowerCase()
      );
      return {
        companyName: company,
        onlinePolicyUserName: existing?.onlinePolicyUserName || "",
        onlinePolicyPassword: existing?.onlinePolicyPassword || "",
        onlinePolicyLoginUrl: existing?.onlinePolicyLoginUrl || "",
      };
    });

  // A row counts as "in use" once any of its LOGIN boxes has a value.
  // companyName is deliberately excluded — every row now carries one, so
  // including it would mark all three as filled and demand a login for each.
  const isCredentialRowFilled = (row) =>
    !!(
      row?.onlinePolicyUserName?.trim() ||
      row?.onlinePolicyPassword?.trim() ||
      row?.onlinePolicyLoginUrl?.trim()
    );

  const validationSchema = Yup.object().shape({
    // A super admin CREATING a user must pick the admin the user belongs to (never himself).
    adminClientId: Yup.string().test("admin-required", "Admin Required", function (value) {
      return !(isSuperAdmin && formType !== "edit") || !!value;
    }),
    mobileNumber: Yup.string().required("Mobile Number Required"),
    userType: Yup.array().required("User Type Required"),
    address: Yup.string().required("Address Required"),
    email: Yup.string()
      .required("Email Required")
      .matches(
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
        "Invalid email format"
      ),
    // Portal credentials are OPTIONAL. The form always renders one blank row,
    // so requiring these outright blocked saving any user who simply has no
    // online-policy login — the row can never be removed when it is the only
    // one. A row is validated only once the operator starts filling it in, so a
    // half-entered login is still caught.
    //
    // `this.parent` (the row) is used instead of Yup's .when() on purpose:
    // three fields each depending on the other two is a cyclic dependency and
    // Yup throws on it.
    providerCredentials: Yup.array().of(
      Yup.object().shape({
        // companyName is owned by the tab, never typed, so it needs no rule.
        onlinePolicyUserName: Yup.string().test(
          "username-required-when-row-used",
          "User Name is required",
          function (value) {
            return !isCredentialRowFilled(this.parent) || !!value;
          }
        ),
        onlinePolicyPassword: Yup.string().test(
          "password-required-when-row-used",
          "Password is required",
          function (value) {
            return !isCredentialRowFilled(this.parent) || !!value;
          }
        ),
      })
    ),
  });

  useEffect(() => {
    GetUserDetails();
  }, []);
  // useEffect(() => {
  //   if (formType === "edit") {
  //     Object.keys(initialValues).forEach((el) => {
  //       if (el !== "providerCredentials") {
  //         initialValues[el] = selectedData[el];
  //       }
  //     });
  //     if (selectedData?.providerCredentials) {
  //       setProviderCredentials(selectedData.providerCredentials);
  //       initialValues.providerCredentials = selectedData.providerCredentials;
  //     }
  //     if (formType === "edit") {
  //       formRef.setFieldValue(initialValues);
  //       formRef.setFieldValue("branchId", selectedData?.branchId?._id);
  //       formRef.setFieldValue("branchManager", selectedData?.branchManager?._id);
  //       formRef.setFieldValue("payoutCycle", selectedData?.payoutCycle);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    if (formType === "edit" && selectedData && formRef.current) {
      // Create a new object with the selected data instead of modifying initialValues
      const editValues = {
        userType: selectedData.userType || [],
        branchId: selectedData.branchId?._id || null,
        branchManager: selectedData.branchManager?._id || null,
        name: selectedData.name || "",
        mobileNumber: selectedData.mobileNumber || "",
        email: selectedData.email || "",
        address: selectedData.address || "",
        clientId: selectedData.clientId || "",
        password: selectedData.password || "",
        aadharNumber: selectedData.aadharNumber || "",
        tds: selectedData.tds || "",
        panNumber: selectedData.panNumber || "",
        gstNumber: selectedData.gstNumber || "",
        bankAccountHolderName: selectedData.bankAccountHolderName || "",
        accountNumber: selectedData.accountNumber || "",
        bankName: selectedData.bankName || "",
        bankBranch: selectedData.bankBranch || "",
        ifscCode: selectedData.ifscCode || "",
        micrNumber: selectedData.micrNumber || "",
        payoutCycle: selectedData.payoutCycle || "",
        idProof: selectedData.idProof || "",
        walletPassword: selectedData.walletPassword || "",
        // Filled in asynchronously below — portal logins are no longer part of
        // the user document, so they are fetched from the ProviderCredential
        // collection instead of read off `selectedData`.
        providerCredentials: buildCredentialRows([]),
      };

      // Check if formRef is available and set the values
      if (formRef.current) {
        formRef.current.setValues(editValues);

        // Set individual fields if needed (though setValues should handle all)
        // formRef.current.setFieldValue("branchId", selectedData?.branchId?._id || "");
        // formRef.current.setFieldValue("branchManager", selectedData?.branchManager?._id || "");
        formRef.current.setFieldValue("payoutCycle", selectedData?.payoutCycle || "");
      }

      // Load the portal logins separately. Deliberately fired AFTER the
      // setValues above rather than from its own effect: setValues replaces the
      // whole form, so a fetch that resolved first would be wiped out by it.
      GetProviderCredentials(selectedData._id).then((creds) => {
        setLoadedCredentials(creds);
        if (!formRef.current) return;
        formRef.current.setFieldValue(
          "providerCredentials",
          buildCredentialRows(creds)
        );
      });
    }

    // View mode renders straight from `loadedCredentials` and has no Formik
    // form to fill, so it only needs the fetch.
    if (formType === "view" && selectedData?._id) {
      GetProviderCredentials(selectedData._id).then(setLoadedCredentials);

      // Update state variables
      setRoleFilter(selectedData.userType || []);
      setBranchValue(selectedData.branchId?.branchName || null);
      setBranchManagerValue(selectedData.branchManager?.name || null);
      setDefaultLocationDetails(selectedData.userType || []);

      // Set formValues for bank details if they exist
      if (selectedData.bankDetails && selectedData.bankDetails.length > 0) {
        setFormValues(selectedData.bankDetails);
      }
      if (selectedData.makemodelids) {
        setMakeModelRows(selectedData.makemodelids);
      }
      if (selectedData.rtocityids) {
        setRtoCityRows(selectedData.rtocityids);
      }
      if (selectedData.makemodelcomboids) {
        setComboRows(selectedData.makemodelcomboids);
      }
    }
  }, [formType, selectedData]); // Add dependencies

  const BranchDetails = () => {
    GetBranch().then((res) => {
      const filterData = res?.data?.filter((item) => item.isEnabled === true);
      const FilterData = filterData.map((e) => {
        return {
          ...e,
          label: e.branchName,
        };
      });
      const ExtrOption = { label: "Add Branch", value: 1, _id: "AddLabel" };
      setBranchData([ExtrOption, ...FilterData]);
    });
  };
  useEffect(() => {
    BranchDetails();
  }, []);

  const UserId = sessionStorage.getItem("UserId");

  const [formValues, setFormValues] = useState(
    formType === "edit" || formType === "view" ? selectedData.bankDetails : []
  );

  // ── Per-user Make & Model discounts ───────────────────────────────────────
  // Assigned by a CLIENT. The Online Policy form restricts its make/model
  // dropdown to these entries and uses this discount instead of the master's.
  // Unlike bankDetails these rows are submitted WITH the user (they are
  // stringified into the FormData below), so they also persist on create.
  const [makeModelRows, setMakeModelRows] = useState(
    formType === "edit" || formType === "view"
      ? selectedData?.makemodelids || []
      : []
  );
  const [openMakeModelDialog, setOpenMakeModelDialog] = useState(false);
  const [makeModelFormType, setMakeModelFormType] = useState("add");
  const [selectedMakeModelRow, setSelectedMakeModelRow] = useState(null);

  // Make & Model master, used to show make/model names for the saved rows.
  // Saved rows only carry { makemodel: ObjectId, Discount } — the schema drops
  // anything else — so the names have to be resolved for display.
  const [makeModelMaster, setMakeModelMaster] = useState([]);
  useEffect(() => {
    let cancelled = false;
    GetMakeModel()
      .then((res) => {
        if (cancelled) return;
        setMakeModelMaster(Array.isArray(res?.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setMakeModelMaster([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const makeModelRowsForTable = React.useMemo(() => {
    const byId = new Map(
      (makeModelMaster || []).map((m) => [String(m._id), m])
    );
    return (makeModelRows || []).map((row) => {
      const master = byId.get(String(row.makemodel));
      return {
        ...row,
        makeLabel: master?.make || row.make || "—",
        modelLabel: master?.model || row.model || "—",
        // A discount only applies when the user switched it on; otherwise the
        // Make & Model master value is used.
        discountLabel:
          row.useOwnDiscount === true &&
            row.Discount !== undefined &&
            row.Discount !== null
            ? `${row.Discount}%`
            : "Master discount",
      };
    });
  }, [makeModelRows, makeModelMaster]);

  // Columns for the Make & Model discount table
  const makeModelHeadCells = [
    { id: "makeLabel", placeMent: "left", disablePadding: false, label: "Make" },
    { id: "modelLabel", placeMent: "left", disablePadding: false, label: "Model" },
    { id: "discountLabel", placeMent: "left", disablePadding: false, label: "Discount (%)" },
  ];

  /** Add a new row, or replace the one at `index` when editing. */
  const handleSaveMakeModelRow = (row, index) => {
    setMakeModelRows((previous) => {
      const rows = [...(previous || [])];
      if (index !== undefined && index !== null && index >= 0) rows[index] = row;
      else rows.push(row);
      return rows;
    });
    setOpenMakeModelDialog(false);
  };

  const handleEditMakeModelRow = (row) => {
    const rows = makeModelRows || [];
    // Match on the reference, not on object identity — the table may hand back
    // a shallow copy.
    const index = rows.findIndex(
      (r) => String(r.makemodel) === String(row.makemodel)
    );
    setSelectedMakeModelRow({ values: row, index });
    setMakeModelFormType("edit");
    setOpenMakeModelDialog(true);
  };

  const handleDeleteMakeModelRow = (row) => {
    setMakeModelRows((previous) =>
      (previous || []).filter(
        (r) => String(r.makemodel) !== String(row.makemodel)
      )
    );
  };

  // ── Per-user RTO City/Location assignments ────────────────────────────────
  // Same shape as the Make & Model block above, minus the discount. The Online
  // Policy RTO dropdown is restricted to these rows with NO fallback: a user
  // with none assigned gets an empty dropdown and must add their own from the
  // RTO City Location page.
  const [rtoCityRows, setRtoCityRows] = useState(
    formType === "edit" || formType === "view"
      ? selectedData?.rtocityids || []
      : []
  );
  const [openRtoCityDialog, setOpenRtoCityDialog] = useState(false);
  const [rtoCityFormType, setRtoCityFormType] = useState("add");
  const [selectedRtoCityRow, setSelectedRtoCityRow] = useState(null);

  // Saved rows only carry { rtoCity: ObjectId } — the schema drops anything
  // else — so the code/region/city have to be resolved from the master.
  const [rtoCityMaster, setRtoCityMaster] = useState([]);
  useEffect(() => {
    let cancelled = false;
    GetRtoCityLocation()
      .then((res) => {
        if (cancelled) return;
        setRtoCityMaster(Array.isArray(res?.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setRtoCityMaster([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const rtoCityRowsForTable = React.useMemo(() => {
    const byId = new Map((rtoCityMaster || []).map((m) => [String(m._id), m]));
    return (rtoCityRows || []).map((row) => {
      const master = byId.get(String(row.rtoCity));
      return {
        ...row,
        rtoCodeLabel: master?.RTOCode || row.RTOCode || "—",
        regionLabel: master?.Region || row.Region || "—",
        cityLabel: master?.city || row.city || "—",
      };
    });
  }, [rtoCityRows, rtoCityMaster]);

  const rtoCityHeadCells = [
    { id: "rtoCodeLabel", placeMent: "left", disablePadding: false, label: "RTO Code" },
    { id: "regionLabel", placeMent: "left", disablePadding: false, label: "Region" },
    { id: "cityLabel", placeMent: "left", disablePadding: false, label: "City" },
  ];

  /** Add a new row, or replace the one at `index` when editing. */
  const handleSaveRtoCityRow = (row, index) => {
    setRtoCityRows((previous) => {
      const rows = [...(previous || [])];
      if (index !== undefined && index !== null && index >= 0) rows[index] = row;
      else rows.push(row);
      return rows;
    });
    setOpenRtoCityDialog(false);
  };

  const handleEditRtoCityRow = (row) => {
    const rows = rtoCityRows || [];
    const index = rows.findIndex(
      (r) => String(r.rtoCity) === String(row.rtoCity)
    );
    setSelectedRtoCityRow({ values: row, index });
    setRtoCityFormType("edit");
    setOpenRtoCityDialog(true);
  };

  const handleDeleteRtoCityRow = (row) => {
    setRtoCityRows((previous) =>
      (previous || []).filter((r) => String(r.rtoCity) !== String(row.rtoCity))
    );
  };

  // ── Per-user Combined Make & Model assignments ────────────────────────────
  // Same shape as the RTO block above (a reference, nothing else). When a user
  // has any, the Online Policy's Combined Make & Model dropdown and the Combined
  // Make and Model page list only these; with none they behave as always.
  const [comboRows, setComboRows] = useState(
    formType === "edit" || formType === "view"
      ? selectedData?.makemodelcomboids || []
      : []
  );
  const [openComboDialog, setOpenComboDialog] = useState(false);

  // Saved rows only carry { makeModelCombo: ObjectId }, so the names are resolved
  // from the combo master. `comboEnabled` is false when the feature is switched
  // off server-side; the tab is hidden then (there is nothing to assign).
  const [comboMaster, setComboMaster] = useState([]);
  const [comboEnabled, setComboEnabled] = useState(true);
  useEffect(() => {
    let cancelled = false;
    GetMakeModelCombo({})
      .then((res) => {
        if (cancelled || !res) return;
        setComboEnabled(res.enabled !== false);
        setComboMaster(Array.isArray(res?.data) ? res.data : []);
      })
      .catch(() => {
        if (!cancelled) setComboMaster([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const comboRowsForTable = React.useMemo(() => {
    const byId = new Map((comboMaster || []).map((c) => [String(c._id), c]));
    return (comboRows || []).map((row) => {
      const master = byId.get(String(row.makeModelCombo));
      return {
        ...row,
        nameLabel: master?.displayName || row.displayName || "—",
        odLabel: master?.odCompany || row.odCompany || "—",
        tpLabel: master?.tpCompany || row.tpCompany || "—",
      };
    });
  }, [comboRows, comboMaster]);

  const comboHeadCells = [
    { id: "nameLabel", placeMent: "left", disablePadding: false, label: "Combined Make & Model" },
    { id: "odLabel", placeMent: "left", disablePadding: false, label: "OD Company" },
    { id: "tpLabel", placeMent: "left", disablePadding: false, label: "TP Company" },
  ];

  const handleSaveComboRow = (row) => {
    setComboRows((previous) => [...(previous || []), row]);
    setOpenComboDialog(false);
  };

  const handleDeleteComboRow = (row) => {
    setComboRows((previous) =>
      (previous || []).filter(
        (r) => String(r.makeModelCombo) !== String(row.makeModelCombo)
      )
    );
  };

  // ── Assignment tabs ───────────────────────────────────────────────────────
  // Bank Details / Make & Model / RTO City are three independent lists. Stacked
  // vertically they pushed the Attachments section far down the page, so they
  // share one tabbed panel instead. Bank Details only exists for some roles, so
  // the tab list is built from what is actually available.
  const [assignmentTab, setAssignmentTab] = useState("bank");
  // Which insurer's login card is on screen. One tab per company.
  const [credentialTab, setCredentialTab] = useState(0);
  // Which way the incoming panel slides in from: moving to a tab on the right
  // enters from the right, and vice versa, so the motion matches the click.
  const [tabSlideFrom, setTabSlideFrom] = useState("right");

  const showBankTab =
    roleFilter.includes("user") || roleFilter.includes("branchManager");

  // A `user` login does not see the Make & Model, RTO City and Combined Make & Model tabs (owner, 2026-10-21): they stay
  // out of the tab bar and their panels stay hidden. Every other login keeps them. The saved assignments are untouched.
  const showAssignmentTabs = sessionStorage.getItem("userType") !== "user";

  const assignmentTabs = React.useMemo(() => {
    const tabs = [];
    if (showBankTab) {
      tabs.push({ key: "bank", label: "Bank Details", count: (formValues || []).length });
    }
    if (showAssignmentTabs) {
      tabs.push({
        key: "makeModel",
        label: "Make & Model Discounts",
        count: (makeModelRows || []).length,
      });
      tabs.push({
        key: "rtoCity",
        label: "RTO City / Location",
        count: (rtoCityRows || []).length,
      });
    }
    // Nothing to assign when the combined feature is switched off.
    if (showAssignmentTabs && comboEnabled) {
      tabs.push({
        key: "combo",
        label: "Combined Make & Model",
        count: (comboRows || []).length,
      });
    }
    return tabs;
  }, [showBankTab, showAssignmentTabs, formValues, makeModelRows, rtoCityRows, comboRows, comboEnabled]);

  // Changing the user type can remove the Bank tab while it is selected.
  useEffect(() => {
    if (!assignmentTabs.some((tab) => tab.key === assignmentTab)) {
      setAssignmentTab(assignmentTabs[0]?.key || "makeModel");
    }
  }, [assignmentTabs, assignmentTab]);

  const handleAssignmentTabChange = (nextKey) => {
    if (nextKey === assignmentTab) return;
    const from = assignmentTabs.findIndex((tab) => tab.key === assignmentTab);
    const to = assignmentTabs.findIndex((tab) => tab.key === nextKey);
    setTabSlideFrom(to > from ? "right" : "left");
    setAssignmentTab(nextKey);
  };

  /**
   * Styling for one tab panel.
   *
   * All three panels stay MOUNTED and are hidden with `display`, rather than
   * being conditionally rendered. Unmounting made the switch glitch: the table
   * tore down, the card height snapped, and a blank frame showed mid-animation.
   * Going from display:none back to block restarts a CSS animation on its own,
   * so the effect still replays on every switch — without a remount.
   *
   * The panel fades ONLY — no transform. MasterCommonTable renders a
   * `stickyHeader` (position: sticky), and a transform on any ancestor becomes
   * that header's containing block: it re-anchors while the animation runs and
   * snaps back when it ends, which is the header "blink". Opacity does not
   * create a containing block, so it is safe. The horizontal movement lives on
   * the header row below instead, which contains nothing sticky.
   *
   * `both` fill mode matters too: without it the panel paints once at full
   * opacity before the animation's first frame lands — a visible flash.
   */
  const assignmentPanelSx = (key, available = true) => ({
    display: assignmentTab === key && available ? "block" : "none",
    animation: "assignmentPanelFade 240ms ease-out both",
    "@keyframes assignmentPanelFade": {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  });

  /** Slide for a panel's header row — safe to transform, nothing sticky here. */
  const assignmentPanelHeaderSx = {
    animation: `${tabSlideFrom === "right"
      ? "assignmentSlideFromRight"
      : "assignmentSlideFromLeft"
      } 260ms cubic-bezier(0.4, 0, 0.2, 1) both`,
    "@keyframes assignmentSlideFromRight": {
      from: { opacity: 0, transform: "translate3d(22px, 0, 0)" },
      to: { opacity: 1, transform: "translate3d(0, 0, 0)" },
    },
    "@keyframes assignmentSlideFromLeft": {
      from: { opacity: 0, transform: "translate3d(-22px, 0, 0)" },
      to: { opacity: 1, transform: "translate3d(0, 0, 0)" },
    },
    "@media (prefers-reduced-motion: reduce)": { animation: "none" },
  };

  const handleInputChange = (index, name, value) => {
    setFormValues((prevFormValues) => {
      const newFormValues = [...prevFormValues];
      newFormValues[index] = {
        ...newFormValues[index],
        [name]: value,
      };
      return newFormValues;
    });
  };

  const NewUserValues = (index, newValue) => {
    if (index !== undefined && index.index !== undefined) {
      setFormValues((prevFormValues) => {
        const updatedFormValues = [...prevFormValues];
        const existingData = updatedFormValues[index.index];

        // if (existingData) {
        updatedFormValues[index.index] = {
          ...existingData,
          bankAccountHolderName: index?.e?.bankAccountHolderName,
          accountNumber: index?.e?.accountNumber,
          bankName: index?.e?.bankName,
          bankBranch: index?.e?.bankBranch,
          ifscCode: index?.e?.ifscCode,
          micrNumber: index?.e?.micrNumber,
          isActive: true,
          panNumber: index?.e?.panNumber,
          aadharNumber: index?.e?.aadharNumber,
          gstNumber: index?.e?.gstNumber,
          tds: index?.e?.tds,
          PANCardProof: index?.e?.PANCardProof,

          PassBookProof: index?.e?.PassBookProof,

          AadharProof: index?.e?.AadharProof,

          GSTProof: index?.e?.GSTProof,
        };
        // }

        return updatedFormValues;
      });
    } else {
      setFormValues((prevFormValues) => [
        ...prevFormValues,
        {
          bankAccountHolderName: index?.e?.bankAccountHolderName,
          accountNumber: index?.e?.accountNumber,
          bankName: index?.e?.bankName,
          bankBranch: index?.e?.bankBranch,
          ifscCode: index?.e?.ifscCode,
          micrNumber: index?.e?.micrNumber,
          isActive: true,
          panNumber: index?.e?.panNumber,
          gstNumber: index?.e?.gstNumber,
          aadharNumber: index?.e?.aadharNumber,
          tds: index?.e?.tds,
          idProof: index?.e?.idProof,
        },
      ]);
    }
  };

  const handleRemoveFields = (values, index) => {
    const additionalIndex = index === 0 ? index : index - 1;
    const newFormValues = [...formValues];
    newFormValues.splice(additionalIndex, 1);
    setFormValues(newFormValues);
  };

  const UserType = sessionStorage.getItem("userType");

  // const onSubmit = async (data) => {

  //   const cleanedData = { ...data };

  //   if (UserType === FilterOption[0].value) {
  //     cleanedData.branchManager = UserId;
  //   }
  //   // else {
  //   //   data.branchManager = data.branchManager;
  //   // }

  //   // data.bankDetails = JSON.stringify(formValues);
  //   setOpenLoader(true);

  //   const originalProviderCredentials = formType === "edit" ? selectedData?.providerCredentials || [] : [];
  //   const newProviderCredentials = providerCredentials;

  //   delete cleanedData.providerCredentials;

  //   let removeWhiteSpace = cleanedData.password.replace(/\s+/g, "");
  //   // console.log("removeWhiteSpace ", removeWhiteSpace);
  //   cleanedData.password = removeWhiteSpace;
  //   const UpdatedTime = new Date();
  //   let formData = new FormData();
  //   cleanedData.updatedAt = UpdatedTime;
  //   // formData.append("providerCredentials", JSON.stringify(cleanedData.providerCredentials));
  //   if (cleanedData.providerCredentials && cleanedData.providerCredentials.length > 0) {

  //     formData.append("providerCredentials", JSON.stringify(cleanedData.providerCredentials));
  //   }
  //   const randomNumber = Math.floor(10000 + Math.random() * 90000);
  //   formType === "edit"
  //     ? (cleanedData.clientId = cleanedData.clientId)
  //     : (cleanedData.clientId = randomNumber);
  //   for (var key in cleanedData) {
  //     // formData.append(key, data[key]);

  //     if (key === 'updatedAt') continue; // Already appended
  //     if (key === 'branchId' || key === 'branchManager') {
  //       if (cleanedData[key] && cleanedData[key] !== '') {
  //         formData.append(key, cleanedData[key]);
  //       }
  //       // If it's null or empty string, DON'T append it at all
  //       continue;
  //     }
  //     if (cleanedData[key] !== null && cleanedData[key] !== undefined && cleanedData[key] !== '') {
  //       formData.append(key, cleanedData[key]);
  //     }
  //   }
  //   formData.append(
  //     AWS_DIRECTORY_NAME.AWS_USER_PHOTO_DIRECTORY_NAME,
  //     data.photo
  //   );
  //   formData.append(
  //     AWS_DIRECTORY_NAME.AWS_PHONEPAY_QR_DIRECTORY_NAME,
  //     data.phonePay
  //   );
  //   formData.append(AWS_DIRECTORY_NAME.AWS_PAYTM_QR_DIRECTORY_NAME, data.paytm);
  //   formData.append(
  //     AWS_DIRECTORY_NAME.AWS_GOOGLEPAY_QR_DIRECTORY_NAME,
  //     data.googlePay
  //   );
  //   formData.append(
  //     AWS_DIRECTORY_NAME.AWS_ADDRESS_PROOF_DIRECTORY_NAME,
  //     data.addrProof
  //   );
  //   formData.append(
  //     AWS_DIRECTORY_NAME.AWS_ID_PROOF_DIRECTORY_NAME,
  //     data.idProof
  //   );
  //   formData.append(
  //     AWS_DIRECTORY_NAME.AWS__PAN_CARD_DIRECTORY_NAME,
  //     data.panCard
  //   );
  //   formData.append(
  //     AWS_DIRECTORY_NAME.AWS_EDUCATIONAL_PROOF_DIRECTORY_NAME,
  //     data.educationalProof
  //   );
  //   formData.append(
  //     AWS_DIRECTORY_NAME.AWS_BANK_BOOK_DIRECTORY_NAME,
  //     data.bankBook
  //   );
  //   formType === "edit"
  //     ? (data.clientId = data.clientId)
  //     : (data.clientId = randomNumber);
  //   // if (formType === "add") {
  //   //   data.createdBy = UserId;
  //   // } else if (formType === "edit") {
  //   //   data.updatedBy = UserId;
  //   // }
  //   // let SubmitType =
  //   //   formType === "edit"
  //   //     ? UpdateUser(selectedData._id, formData)
  //   //     : PostUser(formData);
  //   // SubmitType.then((res) => {
  //   //   if (!res) {
  //   //     setOpenLoader(false);
  //   //   } else {
  //   //     setOpenLoader(false);
  //   //     GetData();
  //   //     setOpenDrawer(false);
  //   //   }
  //   if (formType === "add") {
  //     data.createdBy = UserId;
  //   } else if (formType === "edit") {
  //     data.updatedBy = UserId;
  //   }

  //   try {
  //     let userResponse;

  //     // Step 1: Update/Create user without providerCredentials
  //     if (formType === "edit") {
  //       userResponse = await UpdateUser(selectedData._id, formData);
  //     } else {
  //       userResponse = await PostUser(formData);
  //     }

  //     if (!userResponse) {
  //       setOpenLoader(false);
  //       return;
  //     }

  //     // Step 2: Handle provider credentials separately for edit mode
  //     if (formType === "edit") {
  //       // Check if provider credentials have changed
  //       const credentialsChanged = JSON.stringify(originalProviderCredentials) !== JSON.stringify(newProviderCredentials);

  //       if (credentialsChanged && newProviderCredentials.length > 0) {
  //         try {
  //           // Prepare credentials data for the ChangeCredentials API
  //           const credentialsData = {
  //             userId: selectedData._id, // Send the user ID
  //             providerCredentials: newProviderCredentials.map(cred => {
  //               // Remove _id if present as it might cause issues
  //               const { _id, ...credWithoutId } = cred;
  //               return credWithoutId;
  //             })
  //           };

  //           // Call the ChangeCredentials API
  //           await ChangeCredentials(credentialsData);
  //           ToastSuccess("Provider credentials updated successfully");
  //         } catch (credError) {
  //           console.error("Error updating provider credentials:", credError);
  //           ToastError("Failed to update provider credentials");
  //           // Don't return here - we still want to show success for user update
  //         }
  //       }
  //     } else {
  //       // For add mode, you might want to include provider credentials in the initial user creation
  //       // This depends on your backend API structure
  //       if (newProviderCredentials.length > 0) {
  //         try {
  //           const credentialsData = {
  //             userId: userResponse.data._id, // Get the new user ID from response
  //             providerCredentials: newProviderCredentials.map(cred => {
  //               const { _id, ...credWithoutId } = cred;
  //               return credWithoutId;
  //             })
  //           };

  //           await ChangeCredentials(credentialsData);
  //         } catch (credError) {
  //           console.error("Error adding provider credentials:", credError);
  //         }
  //       }
  //     }

  //     setOpenLoader(false);
  //     GetData();
  //     setOpenDrawer(false);
  //   } catch (error) {
  //     console.log(error);
  //     setOpenDrawer(false);
  //   };
  // };

  const onSubmit = async (data) => {
    console.log("===== onSubmit started =====");
    console.log("Form data received:", data);
    console.log("Form type:", formType);
    console.log("Selected data:", selectedData);

    const cleanedData = { ...data };

    if (UserType === FilterOption[0].value) {
      cleanedData.branchManager = UserId;
    }
    // The password is NOT here: it must be saved exactly as typed.
    ["name","number","address","email"].forEach(
      (item) => (data[item] = data[item]?.toUpperCase())
    );

    // data.bankDetails = JSON.stringify(formValues);

    setOpenLoader(true);

    // Compare and send only REAL rows. The form always carries one blank row,
    // which used to be posted as-is: it was stored on the user as an empty
    // credential and made every save look like a change. Rebuilt field by
    // field so the mongoose subdocument `_id` never travels back either — it
    // is what made the loaded and edited lists differ on an untouched form.
    const normaliseCredentials = (list) =>
      (list || []).filter(isCredentialRowFilled).map((cred) => ({
        companyName: (cred.companyName || "").trim(),
        onlinePolicyUserName: (cred.onlinePolicyUserName || "").trim(),
        onlinePolicyPassword: (cred.onlinePolicyPassword || "").trim(),
        onlinePolicyLoginUrl: (cred.onlinePolicyLoginUrl || "").trim(),
      }));

    const originalProviderCredentials =
      formType === "edit" ? normaliseCredentials(loadedCredentials) : [];
    const newProviderCredentials = normaliseCredentials(data.providerCredentials);

    console.log("Original credentials:", originalProviderCredentials);
    console.log("New credentials:", newProviderCredentials);

    delete cleanedData.providerCredentials;

    let removeWhiteSpace = cleanedData.password.replace(/\s+/g, "");
    cleanedData.password = removeWhiteSpace;
    const UpdatedTime = new Date();
    let formData = new FormData();
    cleanedData.updatedAt = UpdatedTime;

    const randomNumber = Math.floor(10000 + Math.random() * 90000);
    formType === "edit"
      ? (cleanedData.clientId = cleanedData.clientId)
      : (cleanedData.clientId = randomNumber);

    // Sent explicitly below, and only when a super admin is CREATING a user.
    delete cleanedData.adminClientId;

    for (var key in cleanedData) {
      if (key === 'updatedAt') continue;
      if (key === 'branchId' || key === 'branchManager') {
        if (cleanedData[key] && cleanedData[key] !== '') {
          formData.append(key, cleanedData[key]);
        }
        continue;
      }
      if (cleanedData[key] !== null && cleanedData[key] !== undefined && cleanedData[key] !== '') {
        formData.append(key, cleanedData[key]);
      }
    }

    // Append files
    // Per-user Make & Model discounts. Sent WITH the user (unlike bankDetails,
    // which saves through its own endpoint and therefore never persists while
    // CREATING a user). Stringified because the transport is multipart
    // FormData; dao/userDao.js parses it back on both create and update.
    if (isSuperAdmin && formType !== "edit" && data.adminClientId) {
      formData.append("adminClientId", data.adminClientId);
    }
    formData.append("makemodelids", JSON.stringify(makeModelRows || []));
    // Per-user Combined Make & Model assignments — same transport, references only.
    // Always sent, so an emptied list clears them.
    formData.append(
      "makemodelcomboids",
      JSON.stringify(
        (comboRows || []).map((row) => ({ makeModelCombo: row.makeModelCombo }))
      )
    );
    // Per-user RTO City/Location assignments — same transport.
    formData.append(
      "rtocityids",
      JSON.stringify(
        // Only the reference survives the schema; strip the display-only
        // fields so the payload matches RtoCityMapping exactly.
        (rtoCityRows || []).map((row) => ({ rtoCity: row.rtoCity }))
      )
    );

    if (data.photo) formData.append(AWS_DIRECTORY_NAME.AWS_USER_PHOTO_DIRECTORY_NAME, data.photo);
    if (data.phonePay) formData.append(AWS_DIRECTORY_NAME.AWS_PHONEPAY_QR_DIRECTORY_NAME, data.phonePay);
    if (data.paytm) formData.append(AWS_DIRECTORY_NAME.AWS_PAYTM_QR_DIRECTORY_NAME, data.paytm);
    if (data.googlePay) formData.append(AWS_DIRECTORY_NAME.AWS_GOOGLEPAY_QR_DIRECTORY_NAME, data.googlePay);
    if (data.addrProof) formData.append(AWS_DIRECTORY_NAME.AWS_ADDRESS_PROOF_DIRECTORY_NAME, data.addrProof);
    if (data.idProof) formData.append(AWS_DIRECTORY_NAME.AWS_ID_PROOF_DIRECTORY_NAME, data.idProof);
    if (data.panCard) formData.append(AWS_DIRECTORY_NAME.AWS__PAN_CARD_DIRECTORY_NAME, data.panCard);
    if (data.educationalProof) formData.append(AWS_DIRECTORY_NAME.AWS_EDUCATIONAL_PROOF_DIRECTORY_NAME, data.educationalProof);
    if (data.bankBook) formData.append(AWS_DIRECTORY_NAME.AWS_BANK_BOOK_DIRECTORY_NAME, data.bankBook);

    formType === "edit"
      ? (data.clientId = data.clientId)
      : (data.clientId = randomNumber);

    if (formType === "add") {
      data.createdBy = UserId;
    } else if (formType === "edit") {
      data.updatedBy = UserId;
    }

    try {
      let userResponse;

      try {
        if (formType === "edit") {
          if (!selectedData?._id) {
            throw new Error("User ID is missing for update");
          }
          userResponse = await UpdateUser(selectedData._id, formData);
        } else {
          userResponse = await PostUser(formData);
        }

        console.log("User API Response:", userResponse);
      } catch (apiError) {
        console.error("Error in user API call:", apiError);
        console.error("Error response:", apiError.response);
        console.error("Error message:", apiError.message);
        throw new Error(`User API failed: ${apiError.message}`);
      }

      if (!userResponse) {
        console.error("User response is empty");
        // CREATE: PostUser has already shown the server's reason (for example
        // "Mobile Number already exists") and a network failure is caught
        // above, so an empty response here is just "refused" — say nothing more.
        if (formType !== "edit") {
          setOpenLoader(false);
          return;
        }
        throw new Error("No response from user API");
      }

      console.log("User API success, response data:", userResponse);

      // Step 2: Handle provider credentials
      console.log("Step 2: Handling provider credentials...");

      // Same rule for add and edit: post the credentials only when there is
      // something to say. On EDIT that includes going from some rows to none —
      // clearing a login has to reach the server, so an emptied list is still
      // sent whenever it differs from what was loaded. On ADD there is nothing
      // to clear, so an empty list is simply skipped.
      const credentialsChanged =
        JSON.stringify(originalProviderCredentials) !==
        JSON.stringify(newProviderCredentials);
      const targetUserId =
        formType === "edit"
          ? selectedData?._id
          : userResponse.data?._id || userResponse._id || userResponse.id;

      const shouldSendCredentials =
        formType === "edit"
          ? credentialsChanged
          : newProviderCredentials.length > 0;

      console.log("Credentials changed:", credentialsChanged);
      console.log("Sending credentials:", shouldSendCredentials, "for user:", targetUserId);

      if (shouldSendCredentials) {
        if (!targetUserId) {
          console.error("Could not resolve user ID for credentials:", userResponse);
        } else {
          try {
            const credentialsData = {
              userId: targetUserId,
              providerCredentials: newProviderCredentials,
            };

            console.log("Sending credentials data:", credentialsData);

            const credResponse = await ChangeCredentials(credentialsData);
            console.log("Credentials API response:", credResponse);
          } catch (credError) {
            console.error("Error in credentials API:", credError);
            console.error("Credentials error response:", credError.response);
            // Don't throw - the user record itself saved fine
          }
        }
      }

      console.log("===== onSubmit completed successfully =====");
      setOpenLoader(false);
      GetData();
      setOpenDrawer(false);

    } catch (error) {
      console.error("===== ERROR in onSubmit =====");
      console.error("Error object:", error);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);
      if (error.response) {
        console.error("Error response data:", error.response.data);
        console.error("Error response status:", error.response.status);
        console.error("Error response headers:", error.response.headers);
      }

      setOpenLoader(false);
      ToastError(error.response?.data?.message || error.message || "Something went wrong");
    }
  };

  const AddBranchData = () => {
    setOpenBranchDrawer(true);
  };
  const ViewPdfFunction = (e) => {
    if (!e) {
      ToastError("No file Detected");
    } else {
      GetFileFromAWSS3BucketByKey(e)
        .then((res) => res.data.fileData)
        .then((data) => {
          const fileExtension = e.split(".").pop(); // Get file extension
          const fileWindow = window.open("", "_blank");
          if (fileExtension.toLowerCase() === "pdf") {
            // Display PDF using embed tag
            fileWindow?.document?.write(
              `<embed src="data:application/pdf;base64,${data}" width="100%" height="100%" />`
            );
          } else if (
            ["png", "jpg", "jpeg", "gif"].includes(fileExtension.toLowerCase())
          ) {
            // Display image using img tag
            fileWindow?.document?.write(
              `<embed src="data:image/${fileExtension.toLowerCase()};base64,${data}"/>`
            );
          } else {
            // Handle other file types
            ToastError("Unsupported file type");
            fileWindow?.close();
          }
        })
        .catch((err) => ToastError("Something went wrong"));
    }
  };

  const getLabelForValueUser = (value) => {
    const option = PolicyFilterTypes.find((option) => option.value === value);
    return option ? option.label : null;
  };

  const getLabelForValuePayout = (value) => {
    const option = PayoutOption.find((option) => option.value === value);
    return option ? option.label : null;
  };

  const [selectedBankData, setSelectedBankData] = useState([]);
  const EditBankDetails = (index, values) => {
    const bankDetails = selectedData.bankDetails || [];
    const findIndex = bankDetails.indexOf(index);
    console.log("findIndex : ", findIndex);
    console.log("index ::::", index, "values : ", values);
    // const additionalValues = values === 0 ? values : values - 1;
    // setSelectedBankData({ index, values });
    setSelectedBankData({ values: index, index: findIndex });
    setOpenAddBankDrawer(true);
    setEditBankDrawerFormType("edit");
  };

  // written by gokul..
  function handleKeyDown(e) {
    if (e.key === "") {
      e.preventDefault();
    }
  }

  function verifyMobileNumberFunction(e) {
    verifyMobileNumber(e)
      .then(() => {
        // console.log("res")
        setShowMobileErrMsg("");
      })
      .catch((err) => {
        setShowMobileErrMsg(err.response.data.message);
      });
  }

  function verifyEmailAddressFunction(e) {
    verifyEmailAddress(e)
      .then(() => setShowEmailErrMsg(""))
      .catch((err) => setShowEmailErrMsg(err.response.data.message));
  }

  const [isAllow, setIsAllow] = useState({});

  React.useEffect(() => {
    const isallowObj = checkUserType(UserType);
    setIsAllow(isallowObj);
  }, []);
  // const triggerSubmit = () => {
  //   if (formRef) {
  //     formRef.submitForm();
  //   }
  // };

  const triggerSubmit = () => {
    if (formRef.current) {
      formRef.current.submitForm();
    } else {
      console.log("formRef.current is null", formRef);
    }
  };

  return (
    <>
      <div className={`${Styles.MainRenderinContainer} op-form user-form`}>
        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <a
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Home"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a
              className="text-color"
              onClick={() => {
                setOpenDrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"User"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a className="text-color">{"AddUser"}</a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
        </Stack>
        {formType === "view" ? (
          <>
            <div className={Styles.formContainer}>
              <Grid
                container
                className="Master_Card_Container"
                sx={{ border: "none" }}
              >
                <Grid
                  container
                  alignItems={"center"}
                  className="Master_Card_Sub_Container"
                >
                  <Grid item xs={12} sm={6} md={6}>
                    <Typography className="Master_Card_Tittle">
                      {/* {source == "Profile" ? source : "Add User"} */}
                      {`${title} User`}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    className="d-flex justify-content-end"
                  >
                    <CloseIcon
                      onClick={() => setOpenDrawer(false)}
                      sx={{ cursor: "pointer" }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#EAECF0",
                      borderWidth: 1,
                    }}
                  />
                </Grid>
              </Grid>
              <Box className={Styles.formContent}>
                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    User
                  </Typography>

                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          User Type
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.userType?.join(" , ")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.6}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Branch
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.branchId?.branchName || "--"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Branch Manager
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.branchManager?.name || "--"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Personal Details
                  </Typography>

                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Name
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.name}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.6}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Mobile Number
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.mobileNumber || "--"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Email
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.email}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Password
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.password}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.6}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Address
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.address}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Aadhar card Number
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.aadharNumber || "--"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Attach
                  </Typography>

                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Your Photo
                        </Typography>
                        <Stack>
                          <Typography
                            className={Styles.fileView}
                            onClick={() =>
                              ViewPdfFunction(selectedData?.photo?.key)
                            }
                          >
                            <VisibilityOutlinedIcon sx={{ color: "#1E3A5F" }} />
                            {selectedData?.photo?.fileName || "No File"}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.6}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Address Proof
                        </Typography>
                        <Stack>
                          <Typography
                            className={Styles.fileView}
                            onClick={() =>
                              ViewPdfFunction(selectedData?.addressProof?.key)
                            }
                          >
                            <VisibilityOutlinedIcon sx={{ color: "#1E3A5F" }} />
                            {selectedData?.addressProof?.fileName || "No File"}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          ID Proof
                        </Typography>
                        <Stack>
                          <Typography
                            className={Styles.fileView}
                            onClick={() =>
                              ViewPdfFunction(selectedData?.idProof?.key)
                            }
                          >
                            <VisibilityOutlinedIcon sx={{ color: "#1E3A5F" }} />
                            {selectedData?.idProof?.fileName || "No File"}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Pan Card
                        </Typography>
                        <Stack>
                          <Typography
                            className={Styles.fileView}
                            onClick={() =>
                              ViewPdfFunction(selectedData?.panProof?.key)
                            }
                          >
                            <VisibilityOutlinedIcon sx={{ color: "#1E3A5F" }} />
                            {selectedData?.panProof?.fileName || "No File"}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.6}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Educational Proof
                        </Typography>
                        <Stack>
                          <Typography
                            className={Styles.fileView}
                            onClick={() =>
                              ViewPdfFunction(
                                selectedData?.educationalProof?.key
                              )
                            }
                          >
                            <VisibilityOutlinedIcon sx={{ color: "#1E3A5F" }} />
                            {selectedData?.educationalProof?.fileName ||
                              "No File"}
                          </Typography>
                        </Stack>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Bank Proof
                        </Typography>
                        <Stack>
                          <Typography
                            className={Styles.fileView}
                            onClick={() =>
                              ViewPdfFunction(selectedData?.bankBook?.key)
                            }
                          >
                            <VisibilityOutlinedIcon sx={{ color: "#1E3A5F" }} />
                            {selectedData?.bankBook?.fileName || "No File"}
                          </Typography>
                        </Stack>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>
                {/* Online Policy Credentials Section - For View Mode */}
                {showUserCredentialUpdate && (
                <Box sx={{ padding: "0 15px 20px" }}>
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Online Policy Credentials
                  </Typography>

                  {loadedCredentials.length > 0 ? (
                    loadedCredentials.map((cred, index) => (
                      <Box
                        key={index}
                        sx={{
                          mb: 4,
                          p: 3,
                          border: "1px solid #EAECF0",
                          borderRadius: "12px",
                          backgroundColor: "#F9FAFB"
                        }}
                      >
                        <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#1E3A5F", mb: 2 }}>
                          Policy Credentials Set {index + 1}
                        </Typography>
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={4}>
                            <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                              Company Name
                            </Typography>
                            <Typography className={Styles.inputValue}>
                              {cred.companyName || "--"}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                              Login URL
                            </Typography>
                            <Typography className={Styles.inputValue}>
                              {cred.onlinePolicyLoginUrl || "--"}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                              User Name
                            </Typography>
                            <Typography className={Styles.inputValue}>
                              {cred.onlinePolicyUserName || "--"}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                              Password
                            </Typography>
                            <Typography className={Styles.inputValue}>
                              {"•".repeat(8)} {/* Mask the password */}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    ))
                  ) : (
                    <Typography sx={{ color: "#999", textAlign: "center", py: 3 }}>
                      No policy credentials available
                    </Typography>
                  )}
                </Box>
                )}
              </Box>
            </div>
            <div className="container-fluid" style={{ padding: "20px" }}>
              {selectedData?.userType?.includes("user") ||
                selectedData?.userType?.includes("branchManager") ? (
                <>
                  <Typography className="EditPageHeadingTittle">
                    Bank Details
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead sx={{ backgroundColor: "gray" }}>
                        <TableRow>
                          <TableCell align="left" sx={{ color: "white" }}>
                            Account Holder Name
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            Account Number
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            Bank Name
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            Bank Branch
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            IFSC Code
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            MICR Number
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            PAN Number
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            Aadhar Number
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            GST Number
                          </TableCell>
                          <TableCell align="left" sx={{ color: "white" }}>
                            TDS Percentge
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {formValues &&
                          formValues?.map((values, index) => (
                            <TableRow key={index}>
                              <TableCell component="th" scope="row">
                                {values?.bankAccountHolderName?.toUpperCase()}
                              </TableCell>
                              <TableCell align="left">
                                {values?.accountNumber}
                              </TableCell>
                              <TableCell align="left">
                                {values?.bankName}
                              </TableCell>
                              <TableCell align="left">
                                {values?.bankBranch}
                              </TableCell>
                              <TableCell align="left">
                                {values?.ifscCode}
                              </TableCell>
                              <TableCell align="left">
                                {values?.micrNumber}
                              </TableCell>
                              <TableCell align="left">
                                {values?.panNumber}
                              </TableCell>
                              <TableCell align="left">
                                {values?.aadharNumber}
                              </TableCell>
                              <TableCell align="left">
                                {values?.gstNumber}
                              </TableCell>{" "}
                              <TableCell align="left">{values?.tds}</TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                      {formValues?.length < 2 ? (
                        <TableRow>
                          <TableCell
                            colSpan={12}
                            sx={{ textAlign: "center", border: "none" }}
                          >
                            <CloudOffIcon
                              sx={{ fontSize: "100px", color: "#c5c3c3" }}
                            />
                            <br />
                            <Typography sx={{ color: "#c5c3c3" }}>
                              Oops! No Data Found
                            </Typography>
                          </TableCell>
                        </TableRow>
                      ) : null}
                    </Table>
                  </TableContainer>
                  <hr />
                </>
              ) : null}
            </div>
            {/* Online Policy Credentials Section */}
            {/* Online Policy Credentials Section - For View Mode */}
            {showUserCredentialUpdate && (
            <Box sx={{ padding: "0 15px 20px" }}>
              <Typography mt={3} className={Styles.formTitleHead}>
                Online Policy Credentials
              </Typography>

              {loadedCredentials.length > 0 ? (
                loadedCredentials.map((cred, index) => (
                  <Box
                    key={index}
                    sx={{
                      mb: 4,
                      p: 3,
                      border: "1px solid #EAECF0",
                      borderRadius: "12px",
                      backgroundColor: "#F9FAFB"
                    }}
                  >
                    <Typography sx={{ fontWeight: 600, fontSize: "14px", color: "#1E3A5F", mb: 2 }}>
                      Policy Credentials Set {index + 1}
                    </Typography>
                    <Grid container spacing={3}>
                      {/* Plain text, like every other cell in this block. It was
                          a disabled Formik <Field>, but this whole branch
                          renders OUTSIDE the <Formik> below — so it threw as
                          soon as a user actually had a credential to show. */}
                      <Grid item xs={12} sm={4}>
                        <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                          Company Name
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {cred.companyName || "--"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                          Login URL
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {cred.onlinePolicyLoginUrl || "--"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                          User Name
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {cred.onlinePolicyUserName || "--"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                          Password
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {"•".repeat(8)} {/* Mask the password */}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                ))
              ) : (
                <Typography sx={{ color: "#999", textAlign: "center", py: 3 }}>
                  No policy credentials available
                </Typography>
              )}
            </Box>
            )}
          </>
        ) : (
          <>
            <div className={Styles.formContainer} style={{ fontSize: "0px" }}>
              <Grid
                container
                className="Master_Card_Container"
                sx={{ border: "none" }}
              >
                <Grid
                  container
                  alignItems={"center"}
                  className="Master_Card_Sub_Container"
                >
                  <Grid item xs={12} sm={6} md={6}>
                    <Typography className="Master_Card_Tittle">
                      {/* {source == "Profile" ? source : "Add User"} */}
                      {`${title} User`}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    className="d-flex justify-content-end align-items-center"
                    sx={{ gap: 2 }}
                  >
                    <Button
                      className="Master_Card_create_Button"
                      startIcon={
                        <AddIcon
                          sx={{
                            marginRight: "1.5px",
                          }}
                        />
                      }
                      onClick={triggerSubmit}
                    >
                      {title}
                    </Button>
                    <CloseIcon
                      onClick={() => setOpenDrawer(false)}
                      sx={{ cursor: "pointer", fontSize: "24px" }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#EAECF0",
                      borderWidth: 1,
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Formik
                  initialValues={initialValues}
                  onSubmit={(values) => {
                    onSubmit(values);
                  }}
                  validationSchema={validationSchema}
                  // innerRef={(ref) => {
                  //   if (ref) {
                  //     // formRef = ref;
                  //     formikRef;
                  //   }
                  // }}
                  // innerRef={(ref) => {
                  //   formRef = ref; // Assign the ref to formikRef.current
                  // }}
                  innerRef={formRef}
                >
                  {({ setFieldValue, values, errors, touched }) => (
                    <Form className={Styles.formContent}>
                      {/* <Paper sx={{ p: 2, mt: 10 }}> */}
                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          padding: "0 15px",
                        }}
                      >
                        <Typography
                          mt={2}
                          className={Styles.formTitleHead}
                          // Style added by Arun
                          style={{
                            display: source === "Profile" ? "none" : "block",
                          }}
                        >
                          User
                        </Typography>

                        <Grid
                          container
                          spacing={2}
                          mt={1} // Style added by Arun
                          style={{
                            display: source === "Profile" ? "none" : "flex",
                          }}
                        >
                          <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                            {/* <FloatLabel label="Select User type" value={roleFilter}> */}
                            {/* <Autocomplete
                              className="w-100 AutoComplete_InputBox"
                              clearIcon={false}
                              options={FilterOption}
                              name="userType"
                              value={getLabelForValue(values.userType)}
                              onChange={(e, v) => {
                                setRoleFilter(v.value);
                                setFieldValue("userType", v.value);
                              }}
                              renderInput={(params) => <TextField {...params} />}
                              isOptionEqualToValue={(option, value) =>
                                option?.label === value?.label
                              }
                            /> */}
                            <Typography
                              className={Styles.inputTitle}
                              sx={{ fontSize: "12px", mb: 1 }}
                            >
                              User Type
                            </Typography>
                            <Select
                              mode="multiple"
                              dropdownStyle={{ zIndex: 11000 }}
                              className="AutoComplete_InputBox"
                              placeholder="Select User type"
                              maxTagCount="responsive"
                              filterOption={filterOption}
                              filterSort={filterSort}
                              onChange={(selectedValues) => {
                                setFieldValue("userType", selectedValues);
                                setRoleFilter(selectedValues);
                              }}
                              defaultValue={defaultLocationDetails}
                            >
                              {userTypeOptions.map((el) => (
                                <Option value={el.value} key={el.value}>
                                  {el.label}
                                </Option>
                              ))}
                            </Select>
                            {/* </FloatLabel> */}
                            <div className="errorMessage">
                              {errors.userType && touched.userType ? (
                                <div>{errors.userType}</div>
                              ) : (
                                " "
                              )}
                            </div>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={0.7}
                            sx={{
                              display:
                                !roleFilter.includes("user") ||
                                  roleFilter.includes("branchManager")
                                  ? "block"
                                  : "none",
                            }}
                          />
                          {roleFilter.includes("branchManager") ? (
                            <Grid item xs={12} sm={3.6}>
                              {/* <FloatLabel
                              label="Branch"
                              value={openBranchDrawer ? null : values.branchId}
                            > */}
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Branch
                              </Typography>
                              <Autocomplete
                                className="AutoComplete_InputBox"
                                clearIcon={false}
                                options={branchData}
                                value={openBranchDrawer ? null : branchValue}
                                name="branchId"
                                onInputChange={(e, v) => setBranchValue(v)}
                                onChange={(e, v) => {
                                  if (v._id === "AddLabel") {
                                    AddBranchData();
                                  }
                                  setFieldValue("branchId", v?._id);
                                  setBranchValue(v?.label);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select Branch"
                                  />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  option.label === value
                                }
                                renderOption={(props, option, index) => (
                                  <>
                                    <Button
                                      component="li"
                                      {...props}
                                      className={
                                        index.index === 0
                                          ? "AddLabel"
                                          : "selectedLabel"
                                      }
                                      endIcon={
                                        index.index === 0 ? <AddIcon /> : null
                                      }
                                    >
                                      {option.label}
                                    </Button>
                                  </>
                                )}
                              />
                              {/* </FloatLabel> */}
                              <div className="errorMessage">
                                {errors.branchId && touched.branchId ? (
                                  <div>{errors.branchId}</div>
                                ) : (
                                  " "
                                )}
                              </div>
                            </Grid>
                          ) : null}
                          <Grid item xs={12} sm={0.7} />
                          {/* Branch Manager and Payout are no longer asked for. */}
                          <Grid item xs={12} sm={0.7} />
                          {isSuperAdmin && formType !== "edit" ? (
                            <Grid item xs={12} sm={3.5} mb={2}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Admin *
                              </Typography>
                              <Autocomplete
                                className="AutoComplete_InputBox"
                                clearIcon={false}
                                disableClearable
                                options={adminOptions}
                                value={
                                  adminOptions.find(
                                    (o) => o.value === values.adminClientId
                                  ) || null
                                }
                                onChange={(e, v) => setFieldValue("adminClientId", v?.value || "")}
                                getOptionLabel={(o) => o?.label || ""}
                                isOptionEqualToValue={(o, v) => o.value === v.value}
                                renderInput={(params) => (
                                  <TextField {...params} placeholder="Select Admin" />
                                )}
                              />
                              <div className="errorMessage mb-2 mt-2">
                                {errors.adminClientId && touched.adminClientId ? (
                                  <div>{errors.adminClientId}</div>
                                ) : (
                                  " "
                                )}
                              </div>
                            </Grid>
                          ) : null}
                          {/* Changes by Arun */}
                          {roleFilter.includes("user") &&
                            formType === "edit" &&
                            isAllow.isClient ? (
                            <Grid item xs={12} sm={3.6}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Wallet Password
                              </Typography>
                              <Field
                                // readOnly={true}
                                name="walletPassword"
                                placeholder="Enter Wallet Password"
                                className="textField w-100"
                              />
                            </Grid>
                          ) : null}
                        </Grid>
                        {/* <hr // Style added by Arun
                          style={{
                            display: source === "Profile" ? "none" : "block",
                          }}
                        /> */}
                      </Box>
                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          padding: "0 15px",
                        }}
                      >
                        <Typography mt={3} className={Styles.formTitleHead}>
                          Personal Details
                        </Typography>

                        <Stack direction={"row"}>
                          <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} sm={3.5}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Name
                              </Typography>
                              <Field
                                name="name"
                                className="textField w-100"
                                placeholder="Enter Name"
                                style={{ textTransform: "uppercase" }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.6}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Mobile Number
                              </Typography>
                              <Field
                                type="number"
                                name="mobileNumber"
                                className="textField w-100"
                                placeholder="Enter Mobile Number"
                                id="mobileNumber"
                                onKeyDown={handleKeyDown}
                                onBlur={(e) =>
                                  verifyMobileNumberFunction(e.target.value)
                                }
                                style={{ textTransform: "uppercase" }}
                              />
                              {/* </FloatLabel> */}
                              <div className="errorMessage">
                                {errors.mobileNumber && touched.mobileNumber ? (
                                  <div>{errors.mobileNumber}</div>
                                ) : (
                                  showMobileErrMsg
                                )}
                                {/* {showMobileErrMsg} */}
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.5}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Email
                              </Typography>
                              <Field
                                name="email"
                                className="textField w-100"
                                placeholder="Enter Email"
                                id="email"
                                onKeyDown={handleKeyDown}
                                onBlur={(e) =>
                                  verifyEmailAddressFunction(e.target.value)
                                }

                                  style={{ textTransform: "uppercase" }}
                              />
                              {/* </FloatLabel> */}
                              <div className="errorMessage">
                                {errors.email && touched.email ? (
                                  <div>{errors.email}</div>
                                ) : (
                                  <>{showEmailErrMsg}</>
                                )}
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={3.5} sx={{ mb: 1 }}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Password
                              </Typography>
                              <Field
                                name="password"
                                className="textField w-100"
                                placeholder="Enter Password"
                              />
                            </Grid>
                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.6} sx={{ mb: 1 }}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Address
                              </Typography>
                              <Field
                                name="address"
                                placeholder="Enter Address"
                                className="textField w-100"
                                style={{ textTransform: "uppercase" }}
                              />
                              <div className="errorMessage">
                                {errors.address && touched.address ? (
                                  <div>{errors.address}</div>
                                ) : (
                                  " "
                                )}
                              </div>
                            </Grid>
                          </Grid>
                        </Stack>
                      </Box>

                      {/* Bank Details / Make & Model discounts / RTO City are
                          three independent per-user lists, shown one at a time
                          instead of stacked. All three stay mounted in state,
                          so switching tabs never loses unsaved rows.

                          Make & Model and RTO apply to EVERY record in the
                          `user` collection — not gated on the logged-in
                          person's type. (The `client` collection holds admins,
                          who are managed elsewhere.) Read-only in view mode. */}
                      <Box
                        sx={{
                          mx: "10px",
                          mt: 2,
                          border: "1px solid #EAECF0",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <Box
                          sx={{
                            borderBottom: "1px solid #EAECF0",
                            backgroundColor: "#F9FAFB",
                            px: 1,
                          }}
                        >
                          <Tabs
                            value={assignmentTab}
                            onChange={(e, value) => handleAssignmentTabChange(value)}
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            TabIndicatorProps={{
                              sx: { backgroundColor: "#1E3A5F", height: "3px" },
                            }}
                            sx={{
                              minHeight: "42px",
                              "& .MuiTab-root": {
                                textTransform: "none",
                                fontSize: "14px",
                                fontWeight: 500,
                                color: "#667085",
                                minHeight: "42px",
                              },
                              "& .Mui-selected": {
                                color: "#1E3A5F !important",
                                fontWeight: 600,
                              },
                            }}
                          >
                            {assignmentTabs.map((tab) => (
                              <Tab
                                key={tab.key}
                                value={tab.key}
                                iconPosition="end"
                                label={tab.label}
                                icon={
                                  <Chip
                                    size="small"
                                    label={tab.count}
                                    sx={{
                                      height: "20px",
                                      fontSize: "11px",
                                      backgroundColor:
                                        assignmentTab === tab.key
                                          ? "#1E3A5F"
                                          : "#EAECF0",
                                      color:
                                        assignmentTab === tab.key
                                          ? "#FFFFFF"
                                          : "#667085",
                                    }}
                                  />
                                }
                              />
                            ))}
                          </Tabs>
                        </Box>

                        {/* minHeight keeps the card a stable size across tabs:
                            without it an empty list collapses the panel and the
                            switch reads as a jump rather than a slide. The card
                            above has overflow:hidden, so the panel travelling in
                            never causes a horizontal scrollbar. */}
                        <Box sx={{ minHeight: "260px" }}>
                          <Box sx={assignmentPanelSx("bank", showBankTab)}>
                            <Grid
                              container
                              sx={{
                                display: "flex",
                                alignItem: "center",
                                padding: "12px 12px 4px",
                                ...assignmentPanelHeaderSx,
                              }}
                            >
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  sx={{ fontSize: "12px", color: "#667085" }}
                                >
                                  Bank accounts used for this user's payouts.
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                sx={{ display: "flex", justifyContent: "end" }}
                              >
                                <Typography className="Master_Header_Heading">
                                  <Button
                                    className={Styles.addButton}
                                    startIcon={<AddIcon />}
                                    onClick={() => {
                                      setSelectedBankData({});
                                      setOpenAddBankDrawer(true);
                                      setEditBankDrawerFormType("add");
                                    }}
                                  >
                                    Add
                                  </Button>
                                </Typography>
                              </Grid>
                            </Grid>
                            <MasterCommonTable
                              tableConfig={tableConfig}
                              data={formValues}
                              columns={headCells}
                              handleEdit={EditBankDetails}
                              handleDelete={handleRemoveFields}
                            />
                          </Box>

                          <Box sx={assignmentPanelSx("makeModel", showAssignmentTabs)}>
                            <Grid
                              container
                              sx={{
                                display: "flex",
                                alignItem: "center",
                                padding: "12px 12px 4px",
                                ...assignmentPanelHeaderSx,
                              }}
                            >
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  sx={{ fontSize: "12px", color: "#667085" }}
                                >
                                  The Online Policy make/model dropdown is
                                  limited to these, and each row can carry the
                                  user's own discount.
                                </Typography>
                              </Grid>
                              {formType !== "view" ? (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  sx={{ display: "flex", justifyContent: "end" }}
                                >
                                  <Typography className="Master_Header_Heading">
                                    <Button
                                      className={Styles.addButton}
                                      startIcon={<AddIcon />}
                                      onClick={() => {
                                        setSelectedMakeModelRow(null);
                                        setMakeModelFormType("add");
                                        setOpenMakeModelDialog(true);
                                      }}
                                    >
                                      Add
                                    </Button>
                                  </Typography>
                                </Grid>
                              ) : null}
                            </Grid>
                            <MasterCommonTable
                              tableConfig={{
                                isAction: formType !== "view",
                                isEdit: formType !== "view",
                                isDelete: formType !== "view",
                                isView: false,
                              }}
                              data={makeModelRowsForTable}
                              columns={makeModelHeadCells}
                              handleEdit={handleEditMakeModelRow}
                              handleDelete={handleDeleteMakeModelRow}
                            />
                          </Box>

                          <Box sx={assignmentPanelSx("rtoCity", showAssignmentTabs)}>
                            <Grid
                              container
                              sx={{
                                display: "flex",
                                alignItem: "center",
                                padding: "12px 12px 4px",
                                ...assignmentPanelHeaderSx,
                              }}
                            >
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  sx={{ fontSize: "12px", color: "#667085" }}
                                >
                                  The Online Policy RTO dropdown shows only
                                  these. Leave empty and the user sees none.
                                </Typography>
                              </Grid>
                              {formType !== "view" ? (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  sx={{ display: "flex", justifyContent: "end" }}
                                >
                                  <Typography className="Master_Header_Heading">
                                    <Button
                                      className={Styles.addButton}
                                      startIcon={<AddIcon />}
                                      onClick={() => {
                                        setSelectedRtoCityRow(null);
                                        setRtoCityFormType("add");
                                        setOpenRtoCityDialog(true);
                                      }}
                                    >
                                      Add
                                    </Button>
                                  </Typography>
                                </Grid>
                              ) : null}
                            </Grid>
                            <MasterCommonTable
                              tableConfig={{
                                isAction: formType !== "view",
                                isEdit: formType !== "view",
                                isDelete: formType !== "view",
                                isView: false,
                              }}
                              data={rtoCityRowsForTable}
                              columns={rtoCityHeadCells}
                              handleEdit={handleEditRtoCityRow}
                              handleDelete={handleDeleteRtoCityRow}
                            />
                          </Box>

                          <Box sx={assignmentPanelSx("combo", comboEnabled && showAssignmentTabs)}>
                            <Grid
                              container
                              sx={{
                                display: "flex",
                                alignItem: "center",
                                padding: "12px 12px 4px",
                                ...assignmentPanelHeaderSx,
                              }}
                            >
                              <Grid item xs={12} sm={6}>
                                <Typography
                                  sx={{ fontSize: "12px", color: "#667085" }}
                                >
                                  The Online Policy Combined Make &amp; Model
                                  dropdown shows only these. Leave empty and the
                                  user sees them as before.
                                </Typography>
                              </Grid>
                              {formType !== "view" ? (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  sx={{ display: "flex", justifyContent: "end" }}
                                >
                                  <Typography className="Master_Header_Heading">
                                    <Button
                                      className={Styles.addButton}
                                      startIcon={<AddIcon />}
                                      onClick={() => setOpenComboDialog(true)}
                                    >
                                      Add
                                    </Button>
                                  </Typography>
                                </Grid>
                              ) : null}
                            </Grid>
                            <MasterCommonTable
                              tableConfig={{
                                isAction: formType !== "view",
                                isEdit: false,
                                isDelete: formType !== "view",
                                isView: false,
                              }}
                              data={comboRowsForTable}
                              columns={comboHeadCells}
                              handleDelete={handleDeleteComboRow}
                            />
                          </Box>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          padding: "0 15px 20px",
                        }}
                      >
                        <Typography mt={3} className={Styles.formTitleHead}>
                          Attachments
                        </Typography>
                        <Stack direction={"row"}>
                          <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} sm={3.5}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Your Photo
                              </Typography>
                              <Stack className="File-Upload">
                                <FileUploader
                                  handleChange={(e) => {
                                    setFieldValue("photo", e);
                                    setFileTitle({
                                      ...fileTitle,
                                      photo: e.name,
                                    });
                                  }}
                                  name="photo"
                                  label="Upload Your Photo"
                                  dropMessageStyle={{
                                    color: "red",
                                    border: "none",
                                    borderRadius: "0px",
                                  }}
                                />
                                <div className="fileTitle">
                                  {fileTitle.photo ? fileTitle.photo : null}
                                </div>
                              </Stack>
                            </Grid>
                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.6}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Address Proof
                              </Typography>
                              <div className="File-Upload">
                                <FileUploader
                                  handleChange={(e) => {
                                    setFieldValue("addrProof", e);
                                    setFileTitle({
                                      ...fileTitle,
                                      addrProof: e.name,
                                    });
                                  }}
                                  name="addrProof"
                                  label="Upload Your Address Proof"
                                  dropMessageStyle={{
                                    color: "red",
                                    border: "none",
                                    borderRadius: "0px",
                                  }}
                                />
                                <div className="fileTitle">
                                  {fileTitle.addrProof
                                    ? fileTitle.addrProof
                                    : null}
                                </div>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.5}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                ID Proof
                              </Typography>
                              <div className="File-Upload">
                                <FileUploader
                                  handleChange={(e) => {
                                    setFieldValue("idProof", e);
                                    setFileTitle({
                                      ...fileTitle,
                                      idProof: e.name,
                                    });
                                  }}
                                  name="idProof"
                                  label="Upload Your ID Proof"
                                  dropMessageStyle={{
                                    color: "red",
                                    border: "none",
                                    borderRadius: "0px",
                                  }}
                                />
                                <div className="fileTitle">
                                  {fileTitle.idProof ? fileTitle.idProof : null}
                                </div>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={3.5}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Pan Card
                              </Typography>
                              <div className="File-Upload">
                                <FileUploader
                                  handleChange={(e) => {
                                    setFileTitle({
                                      ...fileTitle,
                                      panCard: e.name,
                                    });
                                    setFieldValue("panCard", e);
                                  }}
                                  name="panCard"
                                  label="Upload Your Pan Card"
                                  dropMessageStyle={{
                                    color: "red",
                                    border: "none",
                                    borderRadius: "0px",
                                  }}
                                />
                                <div className="fileTitle">
                                  {fileTitle.panCard ? fileTitle.panCard : null}
                                </div>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.6}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Educational Proof
                              </Typography>
                              <div className="File-Upload">
                                <FileUploader
                                  handleChange={(e) => {
                                    setFieldValue("educationalProof", e);
                                    setFileTitle({
                                      ...fileTitle,
                                      educationalProof: e.name,
                                    });
                                  }}
                                  name="educationalProof"
                                  label="Upload Your Educational Proof"
                                  dropMessageStyle={{
                                    color: "red",
                                    border: "none",
                                    borderRadius: "0px",
                                  }}
                                />
                                <div className="fileTitle">
                                  {fileTitle.educationalProof
                                    ? fileTitle.educationalProof
                                    : null}
                                </div>
                              </div>
                            </Grid>
                            <Grid item xs={12} sm={0.7} />
                            <Grid item xs={12} sm={3.5}>
                              <Typography
                                className={Styles.inputTitle}
                                sx={{ fontSize: "12px", mb: 1 }}
                              >
                                Bank Book
                              </Typography>
                              <div className="File-Upload">
                                <FileUploader
                                  handleChange={(e) => {
                                    setFieldValue("bankBook", e);
                                    setFileTitle({
                                      ...fileTitle,
                                      bankBook: e.name,
                                    });
                                  }}
                                  name="bankBook"
                                  label="Upload Your Bank Book"
                                  dropMessageStyle={{
                                    color: "red",
                                    border: "none",
                                    borderRadius: "0px",
                                  }}
                                />
                                <div className="fileTitle">
                                  {fileTitle.bankBook
                                    ? fileTitle.bankBook
                                    : null}
                                </div>
                              </div>
                            </Grid>
                          </Grid>
                        </Stack>
                      </Box>
                      {/* Online Policy Credentials Section */}
                      {/* Online Policy Credentials Section - Edit Mode — in the Profile drawer only while SHOW_USER_CRETENTIAL_UBDATE is on */}
                      {(source !== "Profile" || showUserCredentialUpdate) && (
                      <Box
                        sx={{
                          padding: "0 15px 20px",
                        }}
                      >
                        <Typography
                          mt={3}
                          mb={1.5}
                          className={Styles.formTitleHead}
                          sx={{ color: "#1E3A5F !important", fontWeight: "600 !important" }}
                        >
                          Online Policy Credentials
                        </Typography>

                        {/* One tab per insurer. The company is a property of the tab, so the
                            same login can never be entered twice — and there is nothing to
                            add or remove, only to fill in or clear. */}
                        <Box
                          sx={{
                            border: "1px solid #E4E8EF",
                            borderRadius: "12px",
                            overflow: "hidden",
                            backgroundColor: "#fff",
                            width: "100%",
                            maxWidth: "760px",
                          }}
                        >
                          {/* Straight off the navbar: navy bar, white labels,
                              gold on hover and when active, $Primary-Navy-Light
                              as the hover fill — the same trio as .NavHeading
                              and the dropdown's h1:hover in Navbar.scss. */}
                          <Tabs
                            value={credentialTab}
                            onChange={(e, next) => setCredentialTab(next)}
                            // Scrollable rather than fullWidth: on a phone three
                            // equal tabs squash the labels into ellipses.
                            variant="scrollable"
                            scrollButtons={false}
                            allowScrollButtonsMobile
                            sx={{
                              minHeight: "46px",
                              backgroundColor: "#1E3A5F",      // $Nav-Color
                              "& .MuiTab-root": {
                                flex: 1,
                                minWidth: { xs: 112, sm: 0 },
                                minHeight: "46px",
                                textTransform: "none",
                                fontFamily: "'Poppins', sans-serif",
                                fontSize: { xs: "12px", sm: "13px" },
                                fontWeight: 500,
                                color: "#FFFFFF",              // $Nav-Text-color
                                opacity: 1,
                                transition: "color .2s ease, background-color .2s ease",
                                "&:hover": {
                                  color: "#D4AF37",            // $Accent-Gold
                                  backgroundColor: "#2E5A8F",  // $Hover-Color
                                },
                              },
                              "& .Mui-selected": {
                                color: "#D4AF37 !important",   // $Accent-Gold
                                fontWeight: 600,
                              },
                              "& .MuiTabs-indicator": {
                                height: "3px",
                                backgroundColor: "#D4AF37",
                              },
                            }}
                          >
                            {availableCompanies.map((company, index) => {
                              const filled = isCredentialRowFilled(values.providerCredentials?.[index]);
                              return (
                                <Tab
                                  key={company}
                                  disableRipple
                                  label={
                                    <Stack direction="row" alignItems="center" spacing={1}>
                                      <span>{company}</span>
                                      {/* A saved login gets a gold dot, so which insurers are
                                          configured is readable without opening each tab.
                                          Unset ones stay muted against the navy. */}
                                      <Box
                                        component="span"
                                        sx={{
                                          width: 7,
                                          height: 7,
                                          borderRadius: "50%",
                                          backgroundColor: filled
                                            ? "#D4AF37"
                                            : "rgba(255,255,255,0.35)",
                                        }}
                                      />
                                    </Stack>
                                  }
                                />
                              );
                            })}
                          </Tabs>

                          {availableCompanies.map((company, index) => {
                            const rowErrors = errors.providerCredentials?.[index] || {};
                            const rowTouched = touched.providerCredentials?.[index] || {};
                            const filled = isCredentialRowFilled(values.providerCredentials?.[index]);

                            return (
                              <Box
                                key={company}
                                // Panels stay mounted and hide with `display` — unmounting
                                // would drop each field's touched/error state on every switch.
                                sx={{
                                  display: credentialTab === index ? "block" : "none",
                                  p: { xs: 2, sm: 3 },
                                }}
                              >
                                <Stack
                                  direction="row"
                                  justifyContent="space-between"
                                  alignItems="center"
                                  mb={2.5}
                                >
                                  <Box>
                                    {/* $Primary-Navy heading over a short
                                        $Accent-Gold rule — the navbar's own
                                        navy/gold pairing, and Poppins like the
                                        rest of the chrome. */}
                                    <Typography
                                      sx={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        color: "#1E3A5F",
                                      }}
                                    >
                                      {company} Portal Login
                                    </Typography>
                                    <Box
                                      sx={{
                                        width: 34,
                                        height: 2,
                                        borderRadius: 1,
                                        backgroundColor: "#D4AF37",
                                        mt: 0.75,
                                        mb: 0.75,
                                      }}
                                    />
                                    <Typography sx={{ fontSize: "12px", color: "#667085" }}>
                                      {filled
                                        ? "Used by the automation for this user's " + company + " policies."
                                        : "Leave blank to use this user's client login instead."}
                                    </Typography>
                                  </Box>

                                  {filled && (
                                    <Button
                                      size="small"
                                      color="error"
                                      startIcon={<DeleteIcon />}
                                      onClick={() => {
                                        setFieldValue(`providerCredentials.${index}.onlinePolicyUserName`, "");
                                        setFieldValue(`providerCredentials.${index}.onlinePolicyPassword`, "");
                                        setFieldValue(`providerCredentials.${index}.onlinePolicyLoginUrl`, "");
                                      }}
                                      sx={{ textTransform: "none", borderRadius: "8px", flexShrink: 0 }}
                                    >
                                      Clear
                                    </Button>
                                  )}
                                </Stack>

                                <Grid container spacing={2.5}>
                                  <Grid item xs={12} sm={6}>
                                    <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                                      User Name
                                    </Typography>
                                    <Field
                                      name={`providerCredentials.${index}.onlinePolicyUserName`}
                                      className="textField w-100"
                                      placeholder="Portal user name"
                                    />
                                    {rowErrors.onlinePolicyUserName && rowTouched.onlinePolicyUserName && (
                                      <div className="errorMessage">{rowErrors.onlinePolicyUserName}</div>
                                    )}
                                  </Grid>

                                  <Grid item xs={12} sm={6}>
                                    <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                                      Password
                                    </Typography>
                                    <div style={{ position: "relative" }}>
                                      <Field
                                        name={`providerCredentials.${index}.onlinePolicyPassword`}
                                        type={showOPPassword ? "text" : "password"}
                                        className="textField w-100"
                                        placeholder="Portal password"
                                      />
                                      <IconButton
                                        onClick={() => setShowOPPassword(!showOPPassword)}
                                        sx={{
                                          position: "absolute",
                                          right: 4,
                                          top: "50%",
                                          transform: "translateY(-50%)",
                                          color: "#667085",
                                        }}
                                        size="small"
                                      >
                                        {showOPPassword ? (
                  <VisibilityOffOutlinedIcon fontSize="small" />
                ) : (
                  <VisibilityOutlinedIcon fontSize="small" />
                )}
                                      </IconButton>
                                    </div>
                                    {rowErrors.onlinePolicyPassword && rowTouched.onlinePolicyPassword && (
                                      <div className="errorMessage">{rowErrors.onlinePolicyPassword}</div>
                                    )}
                                  </Grid>

                                  <Grid item xs={12}>
                                    <Typography className={Styles.inputTitle} sx={{ fontSize: "12px", mb: 1 }}>
                                      Login URL <span style={{ color: "#98A2B3" }}>(optional)</span>
                                    </Typography>
                                    <Field
                                      name={`providerCredentials.${index}.onlinePolicyLoginUrl`}
                                      className="textField w-100"
                                      placeholder={"https://... " + company + " portal login page"}
                                    />
                                  </Grid>
                                </Grid>
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                      )}
                      {/* <hr />
                      <Grid container>
                        <Grid item xs={12} sm={2}>
                          <button className="Common_Button w-100" type="submit">
                            {title}
                          </button>
                        </Grid>
                      </Grid> */}
                      {/* </Paper> */}
                    </Form>
                  )}
                </Formik>
              </Grid>
            </div>
          </>
        )}
        <Loader open={openLoader} />

        {openBranchDrawer ? (
          <Drawer
            open={openBranchDrawer}
            sx={{
              zIndex: 1000,
            }}
            anchor="right"
            PaperProps={{
              sx: { width: { xs: "100%", sm: "25%" } },
            }}
          >
            <AddBranch
              title={"Create"}
              formType={"add"}
              setOpenBranchDrawer={setOpenBranchDrawer}
              GetActiveData={BranchDetails}
            />
          </Drawer>
        ) : null}
        {/* 
          {openAddBankDrawer ? (
            <Drawer
              open={openAddBankDrawer}
              sx={{
                zIndex: 1000,
              }}
              anchor="right"
              PaperProps={{
                sx: { width: { xs: "100%", sm: "25%" } },
              }}
            >
              <AddBankDrawer
                newValue={NewUserValues}
                title={selectedData._id ? "Edit" : "Add"}
                formType={editBankDrawerFormType}
                setOpenAddBankDrawer={setOpenAddBankDrawer}
                selectedBankData={selectedBankData}
              />
            </Drawer>
          ) : null} */}

        {openMakeModelDialog ? (
          <Dialog
            open={openMakeModelDialog}
            onClose={() => setOpenMakeModelDialog(false)}
            TransitionComponent={Transition}
            keepMounted
            // index.scss:623 forces .MuiDialog-paper to width:100% !important,
            // so the size has to be capped through maxWidth, not width.
            PaperProps={{
              sx: { maxWidth: "560px !important", overflow: "visible" },
            }}
          >
            <AddMakeModelDrawer
              formType={makeModelFormType}
              selectedRow={selectedMakeModelRow}
              existingRows={makeModelRows}
              onSave={handleSaveMakeModelRow}
              onClose={() => setOpenMakeModelDialog(false)}
            />
          </Dialog>
        ) : null}

        {openRtoCityDialog ? (
          <Dialog
            open={openRtoCityDialog}
            onClose={() => setOpenRtoCityDialog(false)}
            TransitionComponent={Transition}
            keepMounted
            // index.scss:623 forces .MuiDialog-paper to width:100% !important,
            // so the size has to be capped through maxWidth, not width.
            PaperProps={{
              sx: { maxWidth: "560px !important", overflow: "visible" },
            }}
          >
            <AddRtoCityDrawer
              formType={rtoCityFormType}
              selectedRow={selectedRtoCityRow}
              existingRows={rtoCityRows}
              onSave={handleSaveRtoCityRow}
              onClose={() => setOpenRtoCityDialog(false)}
            />
          </Dialog>
        ) : null}

        {openComboDialog ? (
          <Dialog
            open={openComboDialog}
            onClose={() => setOpenComboDialog(false)}
            TransitionComponent={Transition}
            keepMounted
            PaperProps={{
              sx: { maxWidth: "560px !important", overflow: "visible" },
            }}
          >
            <AddMakeModelComboDrawer
              existingRows={comboRows}
              onSave={handleSaveComboRow}
              onClose={() => setOpenComboDialog(false)}
            />
          </Dialog>
        ) : null}

        {openAddBankDrawer ? (
          <Dialog
            open={openAddBankDrawer}
            TransitionComponent={Transition}
            keepMounted
            aria-describedby="alert-dialog-slide-description"
            PaperProps={{
              style: { maxWidth: "50%" },
            }}
          >
            <AddBankDrawer
              newValue={NewUserValues}
              id={selectedData._id}
              title={selectedData._id ? "Edit" : "Add"}
              formType={editBankDrawerFormType}
              setOpenAddBankDrawer={setOpenAddBankDrawer}
              selectedBankData={selectedBankData}
            />
          </Dialog>
        ) : null}
      </div>
    </>
  );
};

export default AddUser;
